import { bootstrapApplication } from '@angular/platform-browser';

import { APP_CONFIG } from './app/core/providers';
import { startSentry } from './app/core/sentry';
import { AppComponent } from './app/root/app.component';

startSentry();

bootstrapApplication(AppComponent, APP_CONFIG).catch((err: Error) =>
  console.error('Application Boostrapping Error... ', err)
);
